import { render, staticRenderFns } from "./vkList.vue?vue&type=template&id=0c72bf7c&"
import script from "./vkList.vue?vue&type=script&lang=js&"
export * from "./vkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports